/**
 * Small shared render atoms for the RIG surface: rich-text (bold-aware),
 * temperature pip, and the basis chip. Kept tiny and presentational.
 */

import type { BasisFamily, RichText, Temperature } from "../types";
import { TEMP_LABEL } from "../logic";

export function RichTextView({ value }: { value: RichText }): JSX.Element {
  return (
    <>
      {value.map((seg, i) =>
        seg.bold ? <b key={i}>{seg.text}</b> : <span key={i}>{seg.text}</span>,
      )}
    </>
  );
}

export function TempPip({ temp }: { temp: Temperature }): JSX.Element {
  return (
    <span className="rig-temp-pip">
      <span className={`rig-pip rig-${temp}`} />
      {TEMP_LABEL[temp]}
    </span>
  );
}

export function BasisChip({ basis }: { basis: BasisFamily }): JSX.Element {
  return basis === "direct" ? (
    <span className="rig-chip rig-direct rig-mono">DIRECT MATCH</span>
  ) : (
    <span className="rig-chip rig-participant rig-mono">CONSORTIUM PARTICIPANT</span>
  );
}
